<script lang="ts">

    const typesMap: { [type: string]: string } = {
        text                : 'Texto',
        bool                : 'Opción única',
        multiple            : 'Opción múltiple',
        date                : 'Fecha',
        multiple_inputs     : 'Entradas múltiples',
        grid                : 'Rejilla',
    };

    export let type: string;

    let typeString = '';

    $: updateType(type);

    function updateType(type: string): void {
        if (!typesMap[type]) {
            throw new Error('Tipo de pregunta no soportado.');
        }
        typeString = typesMap[type];
    }

</script>

{typeString}
